import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import configData from "../../config.json";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Alert,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment";
//search-select-virtualized
import Select, { createFilter } from "react-select";
import { FixedSizeList as List } from "react-window";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import { getToken } from "../../utils/auth"

const CustomMenuList = (props) => {
  const itemHeight = 35;
  const { options, children, maxHeight, getValue } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * itemHeight;

  return (
    <div>
      <List
        height={maxHeight}
        itemCount={children.length}
        itemSize={itemHeight}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    </div>
  );
};

function MultiAppBar({ tablets, hasToken, handleNewToken }) {
  const params = useParams();
  const navigate = useNavigate();
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  //menu buttons
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  //Data update
  const updates = [
    {
      value: "Update database",
      title: "Database",
    },
    {
      value: "Update media table",
      title: "Media table",
    },
    {
      value: "Update products table",
      title: "Products table",
    },
    {
      value: "Update departments table",
      title: "Departments table",
    },
    {
      value: "Update shelves table",
      title: "Shelves table",
    },
    {
      value: "Update campaigns table",
      title: "Campaigns table",
    },
    {
      value: "Update micro moments table",
      title: "Micro moments table",
    },
    {
      value: "Update database no timestamp",
      title: "Database no timestamp",
    },
  ];
  const [selectedUpdate, setSelectedUpdate] = useState("Update database");
  const [dataStatus, setDataStatus] = useState(null);
  const [updateResults, setUpdateResults] = useState(null);
  const dataUpdate = () => {
    setOpenData(false);
    setDataStatus({
      success:
        "request was sent, waiting for the logs update. May take up to 3 minutes",
      failed: [],
    });
    const token = getToken()
    let newBody = {
      tablets: tablets,
      message: selectedUpdate,
      multi: true,
      retailer: params.retailer,
      store: params.store,
    };

    fetch(`${configData.SERVER_URL}/Tablets/Update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })

      .then((data) => {
        setDataStatus(data);
        setTimeout(updateDataTable, 10000);
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const updateDataTable = () => {
    let x = {
      tablets: tablets,
      retailer: params.retailer,
      store: params.store,
      multi: true,
    };
    const token = getToken()

    fetch(`${configData.SERVER_URL}/Tablets/Update/Check`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(x),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })

      .then((data) => {
        setUpdateResults(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  };

  //Profile Update
  const [profiles, setProfiles] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(0);
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(`${configData.SERVER_URL}/Profiles/Trigger`, { headers })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })

      .then((data) => {
        setProfiles(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  }, [hasToken]);

  const updateProfile = () => {
    setOpenProfile(false);
    const token = getToken()
    let serial_numbers = [];
    tablets.map((tab) => serial_numbers.push(tab.serial_number));
    let newBody = {
      serial_numbers: serial_numbers,
      message: String(selectedProfile),
      retailer: params.retailer,
      store: params.store,
      multi: true,
    };

    fetch(`${configData.SERVER_URL}/Profiles/Trigger`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.response === "success") {
          notify("Profile Update was triggered successfully", "success");
        } else {
          notify(`Profile update Failed, ${data.response}`, "error");
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  };

  //Dialog open/close
  const [openProfile, setOpenProfile] = useState(false);
  const [openData, setOpenData] = useState(false);
  const [openProduct, setOpenProduct] = useState(false);
  const [openMicroMoment, setOpenMicroMoment] = useState(false);
  const [openCampaign, setOpenCampaign] = useState(false);
  const [openTableUpdate, setOpenTableUpdate] = useState(false);
  const handleClickOpenTableUpdate = () => {
    setOpenTableUpdate(true);
  };

  const handleCloseTableUpdate = () => {
    setOpenTableUpdate(false);
  };

  const handleClickOpenData = () => {
    setOpenData(true);
  };

  const handleCloseData = () => {
    setOpenData(false);
  };
  const handleClickOpenProfile = () => {
    setOpenProfile(true);
  };

  const handleCloseProfile = () => {
    setOpenProfile(false);
  };
  const handleClickOpenProduct = () => {
    setOpenProduct(true);
  };

  const handleCloseProduct = () => {
    setOpenProduct(false);
  };
  const handleClickOpenMicroMoment = () => {
    setOpenMicroMoment(true);
  };

  const handleCloseMicroMoment = () => {
    setOpenMicroMoment(false);
  };
  const handleClickOpenCampaign = () => {
    setOpenCampaign(true);
  };

  const handleCloseCampaign = () => {
    setOpenCampaign(false);
  };

  //Products functions
  const [products, setProducts] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(10941);
  const customFilter = createFilter({
    ignoreAccents: true,
    ignoreCase: true,
    trim: true,
  });
  useEffect(() => {
    const token = getToken()
    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/Products/${params.retailer}/${params.store}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setProducts(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  }, [hasToken]);
  const handleProductChange = (selctedOption) => {
    setSelectedProduct(selctedOption.value);
  };
  const addProduct = () => {
    setOpenProduct(false);

    const token = getToken()
    let device_ids = [];
    tablets.map((tab) => device_ids.push(tab.device_id));
    let newBody = {
      device_ids: device_ids,
      message: "Trigger add item",
      product_id: selectedProduct,
      multi: true,
    };

    fetch(
      `${configData.SERVER_URL}/Products/${params.retailer}/${params.store}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(newBody),
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.response === "success") {
          notify("Add product triggered successfully", "success");
        } else {
          notify(`Add product Failed, ${data.response}`, "error");
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  //Micro moment trigger
  const [micromoments, setMicromoments] = useState(null);
  const [selectedMicromoments, setSelectedMicromoments] = useState(141);
  const triggerMicroMoment = () => {
    setOpenMicroMoment(false);
    const token = getToken()
    let device_ids = [];
    tablets.map((tab) => device_ids.push(tab.device_id));
    let newBody = {
      device_ids: device_ids,
      micromomment_id: selectedMicromoments,
      retailer: params.retailer,
      store: params.store,
      multi: true,
    };
    fetch(`${configData.SERVER_URL}/Campaigns/Trigger/Micro`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.response === "success") {
          notify("Micromoment triggered successfully", "success");
        } else {
          notify(`Micromoment Failed, ${data.response}`, "error");
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/Micromoments/${params.retailer}/${params.store}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Error " + res.status);
        }
        return res.json();
      })
      .then((data) => {
        setMicromoments(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  }, [hasToken]);
  const handleMicroMomentchange = (selectedOption) => {
    setSelectedMicromoments(selectedOption.value);
  };

  //Campaigns Functions
  const [campaigns, setCampaigns] = useState(null);
  const [selectedCampaigns, setSelectedCampaigns] = useState(141);

  const triggerCampaign = () => {
    setOpenCampaign(false);
    const token = getToken()
    let device_ids = [];
    tablets.map((tab) => device_ids.push(tab.device_id));
    let newBody = {
      device_ids: device_ids,
      campaign_id: selectedCampaigns,
      retailer: params.retailer,
      store: params.store,
      multi: true,
    };
    fetch(
      `${configData.SERVER_URL}/Campaigns/${params.retailer}/${params.store}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(newBody),
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Error " + res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.response === "success") {
          notify("Campaigns triggered successfully", "success");
        } else {
          notify(`Campaigns Failed, ${data.response}`, "error");
        }
      })

      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/Campaigns/${params.retailer}/${params.store}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Error " + res.status);
        }
        return res.json();
      })
      .then((data) => {
        setCampaigns(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            notify(error, "error");
          }
        }
      });
  }, [hasToken]);
  const handleCampaignchange = (selectedOption) => {
    setSelectedCampaigns(selectedOption.value);
  };

  return (
    <>
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
              onClick={() => {
                navigate("/Home/" + params.retailer + "/" + params.store);
              }}
            >
              Home
            </Typography>

            <Typography
              variant="h5"
              noWrap
              component="a"
              href=""
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              LOGO
            </Typography>
            {/* user menue */}
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <Button
                  onClick={handleOpenUserMenu}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  Actions
                </Button>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {/* Update Data */}
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography textAlign="center" onClick={handleClickOpenData}>
                    Trigger Update Data
                  </Typography>
                  <Dialog open={openData} onClose={handleCloseData}>
                    <DialogTitle>Update Data</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Please select what type of data you would like to
                        update.
                        <br />
                        Choose "Update Database" if you like to update all the
                        data types.
                        <br />
                        <br />
                      </DialogContentText>
                      <TextField
                        id="outlined-select-currency"
                        autoFocus
                        fullWidth
                        select
                        label="Data"
                        helperText="Please select data type"
                        onChange={(e) => setSelectedUpdate(e.target.value)}
                        value={selectedUpdate}
                      >
                        {updates.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.title}
                          </MenuItem>
                        ))}
                      </TextField>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseData}>Cancel</Button>
                      <Button onClick={dataUpdate}>Update</Button>
                    </DialogActions>
                  </Dialog>
                </MenuItem>
                {/* End of update Data */}
                {/* Update Profile */}
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography
                    textAlign="center"
                    onClick={handleClickOpenProfile}
                  >
                    Change Profile
                  </Typography>
                  <Dialog open={openProfile} onClose={handleCloseProfile}>
                    <DialogTitle>Change Profile</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Please select profile to change. The default profile is
                        called "default".
                        <br />
                        <br />
                      </DialogContentText>
                      {profiles && (
                        <TextField
                          id="outlined-select-currency"
                          autoFocus
                          fullWidth
                          select
                          label="Profiles"
                          helperText="Please select new profile"
                          onChange={(e) => setSelectedProfile(e.target.value)}
                          value={selectedProfile}
                        >
                          {profiles.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseProfile}>Cancel</Button>
                      <Button onClick={updateProfile}>Update</Button>
                    </DialogActions>
                  </Dialog>
                </MenuItem>
                {/* end of update profile */}
                {/* Product push */}
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography
                    textAlign="center"
                    onClick={handleClickOpenProduct}
                  >
                    Add Product
                  </Typography>
                  <Dialog open={openProduct} onClose={handleCloseProduct}>
                    <DialogTitle>Add Product</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Please select product to add to the tablets shopping
                        list, you can use the search to type a specific name.
                        <br />
                        <br />
                      </DialogContentText>
                      {products && (
                        <div style={{ minHeight: "35vh" }}>
                          <Select
                            placeholder="Products"
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                height: "60px",
                                marginLeft: "10px",
                              }),
                            }}
                            onChange={handleProductChange}
                            options={products}
                            filterOption={customFilter}
                            components={{
                              MenuList: CustomMenuList,
                            }}
                          />
                        </div>
                      )}
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseProduct}>Cancel</Button>
                      <Button onClick={addProduct}>Update</Button>
                    </DialogActions>
                  </Dialog>
                </MenuItem>
                {/* end of product push */}
                {/* Micro moment change */}
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography
                    textAlign="center"
                    onClick={handleClickOpenMicroMoment}
                  >
                    Trigger micro moment
                  </Typography>
                  <Dialog
                    open={openMicroMoment}
                    onClose={handleCloseMicroMoment}
                  >
                    <DialogTitle>Trigger Micro moment</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Please select micro moment to trigger, notice that not
                        all micro moments appears in all the profiles.
                        <br />
                        <br />
                      </DialogContentText>
                      {micromoments && (
                        <div style={{ minHeight: "35vh" }}>
                          <Select
                            placeholder="MicroMoments"
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                height: "60px",
                                marginLeft: "10px",
                              }),
                            }}
                            onChange={handleMicroMomentchange}
                            options={micromoments}
                            filterOption={customFilter}
                            components={{
                              MenuList: CustomMenuList,
                            }}
                          />
                        </div>
                      )}
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseMicroMoment}>Cancel</Button>
                      <Button onClick={triggerMicroMoment}>Update</Button>
                    </DialogActions>
                  </Dialog>
                </MenuItem>
                {/* end of Micro momwent change */}
                {/* start of the campaigns */}
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography
                    textAlign="center"
                    onClick={handleClickOpenCampaign}
                  >
                    Add Campaign
                  </Typography>
                  <Dialog open={openCampaign} onClose={handleCloseCampaign}>
                    <DialogTitle>Add Campaign</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Please select campaign to add to shopping list.
                        <br />
                        <br />
                      </DialogContentText>
                      {campaigns && (
                        <div style={{ minHeight: "35vh" }}>
                          <Select
                            placeholder="Campaigns"
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                height: "60px",
                                marginLeft: "10px",
                              }),
                            }}
                            onChange={handleCampaignchange}
                            options={campaigns}
                            filterOption={customFilter}
                            components={{
                              MenuList: CustomMenuList,
                            }}
                          />
                        </div>
                      )}
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseCampaign}>Cancel</Button>
                      <Button onClick={triggerCampaign}>Add</Button>
                    </DialogActions>
                  </Dialog>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      {dataStatus && (
        <Alert severity="success">
          {dataStatus.success}
          {dataStatus.failed.length === 0
            ? "        "
            : ", No logs were found: " + dataStatus.failed.toString() + "    "}
          {updateResults && (
            <Button color="success" onClick={handleClickOpenTableUpdate}>
              See results
            </Button>
          )}
          <Dialog
            fullWidth={true}
            maxWidth={"xl"}
            open={openTableUpdate}
            onClose={handleCloseTableUpdate}
            scroll={"paper"}
          >
            <DialogTitle>Update Database Table</DialogTitle>
            <DialogContent>
              <Button onClick={updateDataTable}>Update Table</Button>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Serial Number</TableCell>
                      <TableCell align="center">Media</TableCell>
                      <TableCell align="center">Products</TableCell>
                      <TableCell align="center">Departments</TableCell>
                      <TableCell align="center">Shelves</TableCell>
                      <TableCell align="center">Campaigns</TableCell>
                      <TableCell align="center">Micro-moments</TableCell>
                    </TableRow>
                  </TableHead>
                  {updateResults && (
                    <TableBody>
                      {updateResults.map((tablet, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">
                            {tablet.serial_number}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.media === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={moment(tablet.media_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={moment(tablet.media_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.products === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={moment(tablet.products_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={moment(tablet.products_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.departments === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={moment(tablet.departments_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={moment(tablet.departments_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.shelves === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={moment(tablet.shelves_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={moment(tablet.shelves_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.campaigns === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={moment(tablet.campaigns_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={moment(tablet.campaigns_ts).format(
                                  "HH:mm:ss"
                                )}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.micromoments === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={moment(
                                  tablet.micromoments_ts
                                ).format("HH:mm:ss")}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={moment(
                                  tablet.micromoments_ts
                                ).format("HH:mm:ss")}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </DialogContent>
          </Dialog>
        </Alert>
      )}
    </>
  );
}

export default MultiAppBar;
